import GridKeikka_NewKeikka_AsiakasSelector_HeaderDiv from "../../GridKeikkaEditor/components/GridKeikka_NewKeikka_AsiakasSelector_HeaderDiv";
import { LaskuIcon } from "src/components/icons/LaskuIcons";
import { Switch, Typography } from "@mui/material";
import { useContext, useEffect } from "react";
import { GridKeikka_NewKeikkaContext } from "src/context/GridKeikka_NewKeikkaContext";
import { GridContext } from "src/context/GridContext/GridContext";

export default function GridKeikka_NewKeikka_LaskutusSelector() {
  const {
    isBetoniSuoraLaskutus,
    setIsBetoniSuoraLaskutus,
    isPumppuSuoraLaskutus,
    setIsPumppuSuoraLaskutus,
    betoniAsiakas,
    pumppuAsiakas,
    isLoaded,
  } = useContext(GridKeikka_NewKeikkaContext);
  const { gridKeikka } = useContext(GridContext) || {};

  useEffect(() => {
    if (!isLoaded) return;
    if (gridKeikka?.keikkaId > 0) {
      if (gridKeikka.isBetoniSuoraLaskutus !== isBetoniSuoraLaskutus)
        setIsBetoniSuoraLaskutus(gridKeikka.isBetoniSuoraLaskutus);
      if (gridKeikka.isPumppuSuoraLaskutus !== isPumppuSuoraLaskutus)
        setIsPumppuSuoraLaskutus(gridKeikka.isPumppuSuoraLaskutus);
    }
  }, [gridKeikka?.isBetoniSuoraLaskutus, gridKeikka?.isPumppuSuoraLaskutus, isLoaded]);

  function betoniLaskutusText() {
    let betoniLaskutus = "";
    const betoniToimittajaNimi = betoniAsiakas?.betoniAsiakasNimi;
    const pumppuToimittajaNimi = pumppuAsiakas?.pumppuAsiakasNimi;
    const asiakasNimi = gridKeikka?.asiakasNimi || "asiakas";
    //  const l = gridKeikka;
    if (isBetoniSuoraLaskutus) {
      betoniLaskutus = betoniToimittajaNimi + " laskuttaa " + asiakasNimi + ":ta betonista";
      if (!isPumppuSuoraLaskutus) betoniLaskutus += " ja pumppauksesta";
    } else {
      betoniLaskutus =
        betoniToimittajaNimi + " laskuttaa " + pumppuToimittajaNimi + ":ta betonista";
    }
    return betoniLaskutus;
  }
  function pumppuLaskutusText() {
    let pumppuLaskutus = "";
    const betoniToimittajaNimi = betoniAsiakas?.betoniAsiakasNimi;
    const pumppuToimittajaNimi = pumppuAsiakas?.pumppuAsiakasNimi;
    const asiakasNimi = gridKeikka?.asiakasNimi || "asiakas";
    // const l = gridKeikka;
    if (isPumppuSuoraLaskutus) {
      pumppuLaskutus = pumppuToimittajaNimi + " laskuttaa " + asiakasNimi + ":ta pumppauksesta";
      if (!isBetoniSuoraLaskutus) pumppuLaskutus += " ja betonista";
    } else {
      pumppuLaskutus =
        pumppuToimittajaNimi + " laskuttaa " + betoniToimittajaNimi + ":ta pumppauksesta";
    }
    return pumppuLaskutus;
  }

  const handleBetoniChange = (e) => {
    setIsBetoniSuoraLaskutus(e.target.checked);
  };
  const handlePumppuChange = (e) => {
    setIsPumppuSuoraLaskutus(!e.target.checked);
  };

  return (
    <>
      <div className="newKeikka_paper">
        <GridKeikka_NewKeikka_AsiakasSelector_HeaderDiv
          size="small"
          title="Laskutus"
          Icon={LaskuIcon}
        />
        <div className="newKeikka_buttonList" style={{ flexDirection: "row" }}>
          <div style={{ flex: 1 }}>
            <div className="spaceBetween">
              <Typography>Betonin laskutus</Typography>
              <div>
                <Switch checked={isBetoniSuoraLaskutus || false} onChange={handleBetoniChange} />
              </div>
            </div>
            <Typography variant="body2" color="primary">
              {betoniLaskutusText()}
            </Typography>
          </div>
          <div style={{ flex: 1 }}>
            <div className="spaceBetween">
              <Typography>Pumppauksen laskutus</Typography>
              <div>
                <Switch checked={!isPumppuSuoraLaskutus || false} onChange={handlePumppuChange} />
              </div>
            </div>
            <Typography variant="body2" color="primary">
              {pumppuLaskutusText()}
            </Typography>
          </div>
        </div>
      </div>
    </>
  );
}
